module.exports = "/_next/static/resources/art-086aa70ba84f7bacb3a711e22fb6e0d8.webp";